export const GET_USER_COLOR = 'GET_USER_COLOR';
export const GET_ALL_COLORS = 'GET_ALL_COLORS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const DISSMISS_PROFILE_SUCCESS_MESSAGE = 'DISSMISS_PROFILE_SUCCESS_MESSAGE';

export function getColor(data) {
  return {
    type: GET_USER_COLOR,
    payload: data,
  }
}

export function updateProfile(data) {
  return {
    type: UPDATE_PROFILE,
    payload: data,
  }
}

export function updateProfileError(data) {
  return {
    type: UPDATE_PROFILE_ERROR,
    payload: data,
  }
}

export function dissmissProfileSuccessMessage(data) {
  return {
    type: DISSMISS_PROFILE_SUCCESS_MESSAGE,
    payload: data,
  }
}

export function getAllColors(data) {
  return {
    type: GET_ALL_COLORS,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/profile/index.js